import './index.css';
import { AllContestListHeader, ContestShare, ContestConfirmModal } from '../../component';
import { FlatListWrapper, HeaderWithTimer, RouteWrapper } from '../../../component';
import FlatList from 'flatlist-react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import ContestCardMWeb from '../../component/contest_card/index_mWeb';
import ContestSortingHeaderMWeb from '../../component/contest_sorting_header/index_mWeb';
import ContestFilterMWeb from '../../component/contest_filter/index_mWeb';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const AllContestListMWeb = ({
  allContestList,
  onUpdateChallenge,
  defaultSort,
  onPressFilter,
  contestCategory,
  totalChallenges,
  onPressCard,
  onPressShare,
  matchStatus,
  gameState,
  totalTeamsCount,
  matchItem,
  matchDelayed,
  gameType,
  onApplyFilter,
  onClearFilter,
  contestFilterVisible,
  onPressFilterDismiss,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  onPressJoinContest,
  onPressDismissContestConfirm,
  contestConfirmModal,
  entryFee,
  onPressJoin,
  bonusPercentage,
  onPressBack
}: any) => {
  const renderItem = (item: any) => (
    <ContestCardMWeb
      key={item._id}
      contest={item}
      onPressCard={() => onPressCard(item)}
      onPressShare={() => onPressShare(item)}
      matchStatus={matchStatus}
      gameState={gameState}
      totalTeamsCount={totalTeamsCount}
      matchItem={matchItem}
      matchDelayed={matchDelayed}
      screenName={'ALL_CONTEST'}
      gameType={gameType}
      onPressJoin={onPressJoin}
    />
  );

  const onRefresh = async () => {
    // await getAllContestListAPI();
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer onPressBack={onPressBack} matchItem={matchItem} gameType={gameType} />

        <ContestSortingHeaderMWeb
          challenges={allContestList}
          onUpdateChallenge={onUpdateChallenge}
          defaultSort={defaultSort}
          onPressFilter={onPressFilter}
          isAllContestList={true}
        />
        <AllContestListHeader contestCategory={contestCategory} totalChallenges={totalChallenges} />
        <PullToRefresh onRefresh={onRefresh}>
          <FlatListWrapper>
            <FlatList list={allContestList} renderItem={renderItem} renderOnScroll />
          </FlatListWrapper>
        </PullToRefresh>
        <ContestFilterMWeb
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          visible={contestFilterVisible}
          onPressDismiss={onPressFilterDismiss}
        />
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
        <ContestConfirmModal
          visible={contestConfirmModal}
          onPressDismiss={onPressDismissContestConfirm}
          entryFee={entryFee / 100}
          selectedTeamCount={1}
          joinContest={onPressJoinContest}
          bonusPercentage={bonusPercentage}
        />
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};
export default AllContestListMWeb;
